import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import { FormattedMessage } from "gatsby-plugin-intl";
import PropTypes from "prop-types";
import React from "react";

const Label = ({
  htmlFor,
  className,
  textClasses,
  labelKey,
  icon,
  iconType,
  required = false,
  children,
  color = "black",
}) => {
  return (
    <label
      className={classNames(className, color && `text-${color}`)}
      htmlFor={htmlFor}
    >
      {icon && <FontAwesomeIcon type={iconType} icon={icon} />}
      <span className={textClasses}>
        {children || <FormattedMessage id={labelKey} />}
        {required && <span className="text-red-500"> *</span>}
      </span>
    </label>
  );
};

Label.propTypes = {
  icon: PropTypes.node,
  iconType: PropTypes.string,
  labelKey: PropTypes.string,
  htmlFor: PropTypes.string,
  className: PropTypes.string,
  textClasses: PropTypes.string,
  required: PropTypes.bool,
  color: PropTypes.string,
};

export default Label;
